<template>
    <div id="online-service" >
        <iframe class="service-iframe" src="https://tb.53kf.com/code/wx/d32248f01a9b4a55876fecc313d08ab94/1"></iframe>
    </div>
</template>
<script>

export default {
    data(){
        return {

        }
    },
    methods: {

    },
    created(){
     
    }
}
</script>
<style lang="less" scoped>
    #online-service{
        width: 100%;
        height: 100%;

        .service-iframe{
            width: 100%;
            height: 100%;
        }
    }
</style>
